/**
 * Central export for all SVG icons
 * This file provides a registry of all available icons.
 *
 */

// Import SVG files - webpack will process these and return URLs
import remoteNodeMarkerLight from './remote-node-marker.svg';
import remoteNodeMarkerDark from './remote-node-marker-dark.svg';

/**
 * Icon registry mapping icon names to their light and dark variant URLs.
 *
 * To add a new icon:
 * 1. Add the SVG files to src/assets/icons/ (e.g., my-icon.svg and my-icon-dark.svg)
 * 2. Import them at the top of this file
 * 3. Add an entry to this registry
 */
export const iconRegistry: Record<
  string,
  {
    light: string;
    dark?: string;
  }
> = {
  'remote-node-marker': {
    light: remoteNodeMarkerLight,
    dark: remoteNodeMarkerDark,
  },
};
